{
  "user": {
    "categoryFilters": {
      "groupLabel": "Filter help articles by category"
    },
    "figure": {
      "enlargeImage": "Enlarge image: {alt}",
      "clickToEnlarge": "Click to enlarge"
    },
    "video": {
      "title": "Article walkthrough video"
    },
    "contactPanel": {
      "phoneAbbr": "Phone",
      "phoneLabel": "Phone:"
    },
    "article": {
      "notFoundTitle": "Article not found",
      "notFoundMessage": "This help article does not exist or may have been moved.",
      "backToSupport": "Back to Support",
      "steps": "Steps",
      "relatedArticles": "Related articles",
      "faqTitle": "Frequently asked questions",
      "pageTitle": "{title} {'|'} Support"
    },
    "index": {
      "title": "Support",
      "intro": "Browse help articles below or contact your organization directly.",
      "helpArticles": "Help articles",
      "helpArticlesIntro": "Browse common questions and step-by-step guides.",
      "searchLabel": "Search articles",
      "searchPlaceholder": "Search help articles",
      "noResults": "No articles match your search or selected topic."
    }
  }
}
